var map = {
	"./SPEISEKARTE.pdf": "701d",
	"./banner2_opt.jpg": "8300",
	"./drink_welcome_opt.jpg": "9d21",
	"./food1_opt.jpg": "6461",
	"./food_intro1_opt.jpg": "13ff",
	"./food_intro2_opt.jpg": "3482",
	"./food_intro3_opt.jpg": "3da9",
	"./food_landing_banner_opt.jpg": "cdba",
	"./food_welcome_opt.jpg": "a8d2",
	"./footer_background_opt.jpg": "075a",
	"./fuerstenberg_logo.png": "0aa3",
	"./gastliches_kinzigtal.png": "6f20",
	"./haslach_logo.png": "5a88",
	"./location1_opt.jpg": "b4b2",
	"./logo.svg": "9b19",
	"./logo_black.png": "36b4",
	"./logo_white.png": "428c",
	"./minigolf_opt.jpg": "4e5d",
	"./welcome_opt.jpg": "2418"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";